module.exports = __webpack_public_path__ + "static/media/speaker.de8f009e.png";